export default {"src":"/_next/static/media/wellbeing-claw.ea02c7e7.svg","height":800,"width":800};